export const BUILD_NUMBER = '06e57e'; export const SEQUENTIAL_BUILD_NUMBER = '1451'; export const PACKAGE_VERSION = '3.4.1';export const SELECTED_THEME = 'smartcr';
